(function () {
  const storageKey = 'sw-theme';

  function getPreferredTheme() {
    const stored = localStorage.getItem(storageKey);
    if (stored === 'light' || stored === 'dark') return stored;
    return 'dark';
  }

  function applyTheme(theme) {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem(storageKey, theme);
  }

  applyTheme(getPreferredTheme());

  function syncHeaderHeight() {
    var header = document.querySelector('.sw-header');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--sw-header-total-height',
      header.offsetHeight + 'px'
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);

    document.querySelectorAll('[data-sw-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.querySelector('[data-sw-mobile-nav]');
        if (nav) nav.classList.toggle('is-open');
        window.requestAnimationFrame(syncHeaderHeight);
      });
    });

    document.querySelectorAll('[data-sw-theme-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const next = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
        applyTheme(next);
      });
    });
  });
})();
